import { render, staticRenderFns } from "./ExemptionReport.vue?vue&type=template&id=70904cc0&scoped=true"
import script from "./ExemptionReport.vue?vue&type=script&lang=js"
export * from "./ExemptionReport.vue?vue&type=script&lang=js"
import style0 from "./ExemptionReport.vue?vue&type=style&index=0&id=70904cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70904cc0",
  null
  
)

export default component.exports